import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../store"
import BaseApi from "../../api/api"

type initialStateType = {
  wb: {
    hasAccess: boolean
    updateCardStatus?: string
    errors?: { type: string; errors: string[]; data?: any }[]
    updateMediaStatus?: string
    mediaErrors?: { type: string; errors: string[]; data?: any }[]
    deleteCardStatus?: string
    deleteCardErrors?: { type: string; errors: string[]; data?: any }[]
  }
}

const initialState: initialStateType = {
  wb: {
    hasAccess: false,
    errors: [],
    mediaErrors: [],
    deleteCardErrors: [],
  },
}

const contentSlice = createSlice({
  name: "contentState",
  initialState,
  reducers: {
    setContentState: (state, action: PayloadAction<initialStateType>) => {
      state.wb = action.payload.wb
    },
  },
})

export const updateContentState = createAsyncThunk(
  "contentState/update",
  async (_, { dispatch }) => {
    const response = await BaseApi.contentState()
    dispatch(setContentState(response.data))
    return response.data
  },
)

export const selectWbContent = (state: RootState) => state.contentState.wb

export default contentSlice.reducer

export const { setContentState } = contentSlice.actions
